import { ICenter } from "./center";

 export interface IFullDonor {
    id: number;
    isDeleted: boolean;
    donorType: string;
    isActive: boolean;
    isExportable: boolean;
    isViableBridge: boolean;
    isInDonorFollowup: boolean;
    isInFollowupProgram: boolean;
    nddStatus: number;
    isWorkedUp: number;
    testStatus: number;
    donationStartDate: Date;
    donationEndDate: Date;
    gender: string;
    race: string;
    alias: string;
    hasFrozenSamples: boolean;
    hasSamplesAtViracor: boolean;
    cryoStoredAtNkrLabDateTime: Date;
    hasCtScanOnline: boolean;
    lastCryoOrder: Date;
    unosId: string;
    crossReferenceHint: string;
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    phone1: string;
    phone2: string;
    email: string;
    phiFullName: string;
    phiAddr1: string;
    phiAddr2: string;
    phiCity: string;
    phiState: string;
    phiPostalCode: string;
    usePhlebotomy: number;
    phiDOB: Date;
    phiPhone: string;
    phiEmail: string;
    source: string;
    height: number;
    weight: number;
    hasBeenInTbHousehold: boolean;
    hasWorkRelatedRisk: boolean;
    hasTravelOrImmigrationRisk: boolean;
    hasStrongyloidesRisk: boolean;
    hasChagasDiseaseRisk: boolean;
    isDonorMedicallySound: boolean;
    bloodType: string;
    dateOfBirth: Date;
    createdOn: number;
    dateRegistered: Date;
    dateUpdated: number;
    dateGotNote: Date;
    comments: string;
    position: number;
    statusId: number;
    surgeonContactId: number;
    surgeonContact: string;
    kidneyPickupDateTime: string;
    kidneyPickupDateTimeBackup: string;
    kidneyPickupDateTimeActual: string;
    kidneyArrivalDateTime: string;
    kidneyArrivalDateTimeBackup: string;
    kidneyArrivalDateTimeActual: string;
    flightRouteOrGround: string;
    flightRouteOrGroundBackup: string;
    flightRouteOrGroundActual: string;
    transportMethodId: number;
    transportMethodBackup: number;
    transportMethodActual: number;
    transportCost: string;
    transportCostBackup: string;
    transportCostActual: string;
    flightCarrierAndNumber: string;
    flightCarrierAndNumberBackup: string;
    flightCarrierAndNumberActual: string;
    pickupGroundMiles: string;
    pickupGroundMilesBackup: string;
    pickupGroundMilesActual: string;
    dropoffGroundMiles: string;
    dropoffGroundMilesBackup: string;
    dropoffGroundMilesActual: string;
    flightDepartureTime: string;
    flightDepartureTimeBackup: string;
    flightDepartureTimeActual: string;
    flightArrivalTime: string;
    flightArrivalTimeBackup: string;
    flightArrivalTimeActual: string;
    leg2DepartureTime: string;
    leg2DepartureTimeActual: string;
    leg2DepartureTimeBackup: string;
    leg2ArrivalTime: string;
    leg2ArrivalTimeActual: string;
    leg2ArrivalTimeBackup: string;
    tenderedToAirlineActual: string;
    recoveredFromAirlineActual: string;
    deliveryLocation: string;
    deliveredTo: string;
    centerId: number;
    rdnManagingCenter: number;
    recipientId: number;
    coordinatorId: number;
    userId: number;
    registrationId: number;
    originalRecipientId: number;
    adpRecipientId: number;
    hospitalState: string;
    hospitalZip: string;
    clusterId: number;
    originCenterId: number;
    center: ICenter;
}
